import React, { useState } from 'react';
import axios from 'axios';
import './CommentForm.css';

const CommentForm = ({ postId, onCommentSubmitted }) => {
  const [formData, setFormData] = useState({
    author: '',
    content: ''
  });
  const [submitStatus, setSubmitStatus] = useState({
    message: '',
    isError: false
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend';
      await axios.post(`${apiUrl}/api/comments`, {
        ...formData,
        email: 'anonymous@example.com', // Provide a default email since backend might require it
        postId
      });

      setSubmitStatus({
        message: 'Komentar je uspešno poslat i čeka odobrenje administratora.',
        isError: false
      });

      // Reset form
      setFormData({
        author: '',
        content: ''
      });

      if (onCommentSubmitted) {
        onCommentSubmitted();
      }
    } catch (error) {
      setSubmitStatus({
        message: 'Došlo je do greške prilikom slanja komentara. Molimo pokušajte ponovo.',
        isError: true
      });
    }
  };

  return (
    <div className="comment-form-container">
      <h3>Ostavite komentar</h3>
      <form onSubmit={handleSubmit} className="comment-form">
        <div className="form-group">
          <label htmlFor="author">Vaše ime *</label>
          <input
            type="text"
            id="author"
            name="author"
            value={formData.author}
            onChange={handleChange}
            required
            placeholder="Unesite vaše ime"
          />
        </div>

        <div className="form-group">
          <label htmlFor="content">Tekst komentara *</label>
          <textarea
            id="content"
            name="content"
            value={formData.content}
            onChange={handleChange}
            required
            rows="4"
            placeholder="Unesite vaš komentar..."
          />
        </div>

        {submitStatus.message && (
          <div className={`status-message ${submitStatus.isError ? 'error' : 'success'}`}>
            {submitStatus.message}
          </div>
        )}

        <button type="submit" className="submit-button">
          Objavi
        </button>
      </form>
    </div>
  );
};

export default CommentForm; 